import { render, staticRenderFns } from "./homepageTemplate.vue?vue&type=template&id=05ac4078&scoped=true"
import script from "./homepageTemplate.vue?vue&type=script&lang=js"
export * from "./homepageTemplate.vue?vue&type=script&lang=js"
import style0 from "./homepageTemplate.vue?vue&type=style&index=0&id=05ac4078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ac4078",
  null
  
)

export default component.exports